// extracted by mini-css-extract-plugin
export default {"countdownText":"CountdownTimer_countdownText__mSflQ","pulse":"CountdownTimer_pulse__nbRNW"};